import { cart, combo, user } from 'core/use-cases';

/**
 * This list of messages for handling success notifications
 *
 */
export const success = {
  [cart.actions.itemAddFetch.success.type]: 'Item adicionado ao carrinho',
  [cart.actions.itemDeleteFetch.success.type]: 'Item removido do carrinho',
  [cart.actions.itemUpdateFetch.success.type]: 'Item atualizado com sucesso',
  [combo.actions.comboPost.success.type]: 'O produto {sku} foi adicionado com sucesso.',
  [user.actions.userBuyIntentionFetch.success.type]:
    'Avisaremos por e-mail ou WhatsApp quando o produto {name} estiver disponível. Lembre-se: o aviso não garante estoque.',
};
